import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAllLegalDocument = createAsyncThunk(
  "masters/state/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.LegalDocument}?name=${filter?.name || ""}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Get a specific state
export const GetLegalDocument = createAsyncThunk(
  "masters/state/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.LegalDocument}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create a new state
export const AddLegalDocument = createAsyncThunk(
  "masters/state/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.LegalDocument, data);
      return res; // The new state object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Update a state
export const UpdateLegalDocument = createAsyncThunk(
  "masters/state/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.LegalDocument}/${id}`, {
        name: data.name,
        country_id: data.country_id,
      });
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Delete a state
export const DeleteLegalDocument = createAsyncThunk(
  "masters/state/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.LegalDocument}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Change the status of a state
export const StatusLegalDocument = createAsyncThunk(
  "masters/state/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.LegalDocument}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "privacy-agreement",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(GetLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(UpdateLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeleteLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = state.data.filter(
        //   (stateItem) => stateItem.id !== action.payload
        // );
        state.data = state.data.filter(
          (stateItem) => stateItem.id !== action.payload
        );
      })
      .addCase(DeleteLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(StatusLegalDocument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusLegalDocument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (stateItem) => stateItem.id === action.payload?.id
        );
        if (index !== -1) {
          state.data[index].status = !state.data[index].status;
        }
      })
      .addCase(StatusLegalDocument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
